import React from "react";

import LookingForSomethingIcon from "@/icons/LookingForSomethingIcon/";
import {
  containerCss,
  headingCss,
  iconCss,
  messageCss,
} from "./NoAssignedWorkError.style";

const NoAssignedWorkError = () => {
  return (
    <div css={containerCss}>
      <LookingForSomethingIcon css={iconCss} />
      <div>
        <h3 css={headingCss}> No assigned work to review</h3>
        <p css={messageCss}>
          {" "}
          Any articles you assign will appear here for your review. To create an
          assignment, go to the article and select Assign.{" "}
        </p>
      </div>
    </div>
  );
};

export default NoAssignedWorkError;
